// Página pública "Entrar na Rede Everlog" (PO1-3647, épico PO1-3359). Usa o
// cliente anônimo: a página roda na mesma origem da área logada e um operador
// do Hub que a abrisse mandaria a própria sessão junto (ver apiPublic.js).
// Contrato: contratos-rede-everlog.md, seção 1.
import apiPublic from "./apiPublic";

const BASE = "/public/rede-everlog";

// { ativa, captcha: { token, question, expiresInSeconds } }; 404 = Rede desligada.
export async function obterConfigRede() {
  const { data } = await apiPublic.get(`${BASE}/config`);
  return data;
}

// Captcha novo depois de um erro (o token anterior já foi consumido).
export async function novoCaptchaRede() {
  const { data } = await apiPublic.get(`${BASE}/captcha`);
  return data;
}

// [{ id, sigla, nome }]
export async function listarEstadosRede() {
  const { data } = await apiPublic.get(`${BASE}/estados`);
  return (data && data.items) || [];
}

// [{ id, nome, idEstado, uf }], até 20; q com 2+ letras.
export async function buscarCidadesRede(uf, q) {
  const { data } = await apiPublic.get(`${BASE}/cidades`, { params: { uf, q: q || undefined } });
  return (data && data.items) || [];
}

// { disponivel: true, razaoSocial, fantasia, situacao, ativa, matriz } ou
// { disponivel: false } quando a Receita não respondeu (a página deixa digitar).
export async function consultarCnpjRede(cnpj) {
  const { data } = await apiPublic.get(`${BASE}/cnpj/${encodeURIComponent(String(cnpj || "").replace(/\D/g, ""))}`);
  return data;
}

// multipart: campos texto + arquivos em `tabelas` (0 a 5). `cobertura` e `api`
// vão como JSON string. Resposta 201 { protocolo }.
export async function enviarPedidoRede({ cnpj, razaoSocial, nomeResponsavel, email, telefone, cobertura, api, visivelEmbarcadores, captchaToken, captchaAnswer }, arquivos = []) {
  const form = new FormData();
  form.append("cnpj", String(cnpj || "").replace(/\D/g, ""));
  if (razaoSocial) form.append("razaoSocial", String(razaoSocial).trim());
  form.append("nomeResponsavel", String(nomeResponsavel || "").trim());
  form.append("email", String(email || "").trim());
  form.append("telefone", String(telefone || "").trim());
  form.append("cobertura", JSON.stringify(cobertura || []));
  if (api) form.append("api", JSON.stringify(api));
  form.append("visivelEmbarcadores", visivelEmbarcadores ? "true" : "false");
  form.append("captchaToken", captchaToken || "");
  form.append("captchaAnswer", String(captchaAnswer || "").trim());
  (arquivos || []).forEach((f) => form.append("tabelas", f, f.name));
  const { data } = await apiPublic.post(`${BASE}/pedido`, form, { headers: { "content-type": "multipart/form-data" } });
  return data;
}
